import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    const exchange = async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        window.history.replaceState(null, "", window.location.pathname);
        navigate(window.location.pathname, { replace: true, state: { user: data } });
      } catch (err) {
        const detail = err.response?.data?.detail;
        toast.error(typeof detail === "string" ? detail : "Google sign-in failed");
        window.history.replaceState(null, "", window.location.pathname);
        navigate(window.location.pathname, { replace: true });
      }
    };
    exchange();
  }, [navigate]);

  return (
    <main className="min-h-screen bg-alabaster flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="flex items-center gap-3 text-navy font-semibold">
        <Loader2 className="h-5 w-5 animate-spin text-tealbrand" /> Signing you in with Google…
      </div>
    </main>
  );
};

export default AuthCallback;
